import { render, staticRenderFns } from "./EmailsBox.vue?vue&type=template&id=69ab50d6&scoped=true&"
import script from "./EmailsBox.vue?vue&type=script&lang=js&"
export * from "./EmailsBox.vue?vue&type=script&lang=js&"
import style0 from "./EmailsBox.vue?vue&type=style&index=0&id=69ab50d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69ab50d6",
  null
  
)

export default component.exports